import { get } from './utils'
import { CONNECT_ENDPOINTS } from './constants'

const fetchPaymentMethodList = async payerId => {
  const url = `${CONNECT_ENDPOINTS.PAYMENT_METHODS}?payerId=${payerId}`
  return get(url)
}

export { fetchPaymentMethodList }
